import Message from "./components/Message";
import { useEffect, useRef } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { Stack } from "@mui/material";
import { useGetMessagesQuery } from "src/api/services/messagesApi";

interface Props {
  threadSlug: string;
}

const MessagesList = ({ threadSlug }: Props) => {
  const { data: messages = [] } = useGetMessagesQuery(threadSlug || skipToken);

  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <Stack
      sx={{
        overflowY: "scroll",
        height: "500px",
        mt: 2,
        mb: 2,
        pl: 0.5,
        pr: 0.5,
      }}
      role="list"
      aria-label="Messages"
    >
      {messages.map((message) => (
        <Message message={message} key={message.public_id} />
      ))}
      <div ref={bottomRef} />
    </Stack>
  );
};

export default MessagesList;
